<template>
  <v-col
    v-if="isObjectCreated"
    cols="auto"
    align-self="center"
  >
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.to-left')"
      :disabled="!isMovable"
      @click="moveTo(0, objectCreated.y)"
    >
      <v-icon>mdi-format-horizontal-align-left</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.center-x')"
      :disabled="!isMovable"
      @click="
        moveTo(
          creationController.projectSize.width / 2 - (objectCreated.width * objectCreated.scaleX) / 2,
          objectCreated.y
        )
      "
    >
      <v-icon>mdi-format-horizontal-align-center</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.to-right')"
      :disabled="!isMovable"
      @click="
        moveTo(creationController.projectSize.width - objectCreated.width * objectCreated.scaleX, objectCreated.y)
      "
    >
      <v-icon>mdi-format-horizontal-align-right</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.to-top')"
      :disabled="!isMovable"
      @click="moveTo(objectCreated.x, 0)"
    >
      <v-icon>mdi-format-vertical-align-top</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.center-y')"
      :disabled="!isMovable"
      @click="
        moveTo(
          objectCreated.x,
          creationController.projectSize.height / 2 - (objectCreated.height * objectCreated.scaleY) / 2
        )
      "
    >
      <v-icon>mdi-format-vertical-align-center</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.to-bottom')"
      :disabled="!isMovable"
      @click="
        moveTo(objectCreated.x, creationController.projectSize.height - objectCreated.height * objectCreated.scaleY)
      "
    >
      <v-icon>mdi-format-vertical-align-bottom</v-icon>
    </v-btn>
    <v-btn
      icon
      text
      :title="$t('creation.toolbar.fill')"
      :disabled="!isMovable"
      @click="fullscreen"
    >
      <v-icon>mdi-fullscreen</v-icon>
    </v-btn>
  </v-col>
</template>

<script>
function checkValueInt(value, defaultValue) {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return defaultValue;
  }
  return parsed;
}

function checkValueFloat(value) {
  const parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return 0.01;
  }
  return parsed;
}

export default {
  props: {
    objectCreated: {
      type: Object,
      default: () => {},
    },
    currentTransformer: {
      type: Object,
      default: () => {},
    },
    creationController: {
      type: Object,
      default: () => {},
    },
    isObjectCreated: {
      type: Boolean,
      default: false,
    },
    partial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    currentX: {
      get() {
        return checkValueInt(this.objectCreated.x, 0).toFixed(0);
      },
      set(value) {
        this.objectCreated.x = checkValueInt(value, 0).toFixed(0);
      },
    },
    currentY: {
      get() {
        return checkValueInt(this.objectCreated.y, 0).toFixed(0);
      },
      set(value) {
        this.objectCreated.y = checkValueInt(value, 0).toFixed(0);
      },
    },
    currentWidth: {
      get() {
        return checkValueInt(this.objectCreated.width, 1).toFixed(0);
      },
      set(value) {
        this.objectCreated.width = checkValueInt(value, 1);
      },
    },
    currentHeight: {
      get() {
        return checkValueInt(this.objectCreated.height, 1).toFixed(0);
      },
      set(value) {
        this.objectCreated.height = checkValueInt(value, 1);
      },
    },
    currentScaleX: {
      get() {
        return checkValueFloat(this.objectCreated.scaleX).toFixed(2);
      },
      set(value) {
        this.objectCreated.scaleX = checkValueFloat(value).toFixed(2);
      },
    },
    currentScaleY: {
      get() {
        return checkValueFloat(this.objectCreated.scaleY).toFixed(2);
      },
      set(value) {
        this.objectCreated.scaleY = checkValueFloat(value).toFixed(2);
      },
    },
    isMovable() {
      // Check movable to authorize resize
      let isMovable = false;
      if (this.objectCreated !== undefined) {
        if (this.objectCreated.movable !== undefined) {
          if (this.objectCreated.movable) {
            isMovable = true;
          }
        } else {
          isMovable = true;
        }
      } else {
        isMovable = true;
      }
      return isMovable;
    },
  },
  methods: {
    moveTo(x, y) {
      this.currentX = checkValueInt(x, 0);
      this.currentY = checkValueInt(y, 0);
    },
    fullscreen() {
      this.currentX = 0;
      this.currentY = 0;
      this.currentScaleX = 1;
      this.currentScaleY = 1;
      this.currentWidth = this.creationController.projectSize.width;
      this.currentHeight = this.creationController.projectSize.height;
    },
  },
};
</script>

<style></style>
